module.exports = __webpack_public_path__ + "img/terms.eafb7d21.jpg";